import { createTheme } from "@mui/material/styles";
import { deepPurple } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    primary: {
      main: deepPurple[600],
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          borderRadius: "0.375rem",
          backgroundColor: deepPurple[600],
          "&:hover": {
            backgroundColor: deepPurple[700],
          },
        },
        outlined: {
          borderRadius: "0.25rem",
          borderColor: deepPurple[400],
          "&:hover": {
            borderColor: deepPurple[400],
            backgroundColor: deepPurple[50],
          },
        },
        text: {
          color: deepPurple[400],
          borderColor: deepPurple[400],
          borderRadius: "0.25rem",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        caption: {
          color: "rgba(0, 0, 0, 0.6)",
        },
      },
    },
  },
});

export default theme;
